import { EN_TRANSLATIONS, type EnTranslations } from "./en";

type DeepStringOverrides<T> = T extends string
  ? string
  : T extends object
    ? { [K in keyof T]?: DeepStringOverrides<T[K]> }
    : T;

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function deepMerge(
  base: Record<string, unknown>,
  overrides: Record<string, unknown>,
): Record<string, unknown> {
  const result = { ...base };

  for (const key of Object.keys(overrides)) {
    const override = overrides[key];
    if (override === undefined) {
      continue;
    }

    const baseValue = base[key];
    if (isPlainObject(baseValue) && isPlainObject(override)) {
      result[key] = deepMerge(baseValue, override);
      continue;
    }

    result[key] = override;
  }

  return result;
}

export function createLocaleMessages(
  overrides: DeepStringOverrides<EnTranslations>,
): EnTranslations {
  const clone = JSON.parse(JSON.stringify(EN_TRANSLATIONS)) as EnTranslations;
  return deepMerge(
    clone as unknown as Record<string, unknown>,
    overrides as unknown as Record<string, unknown>,
  ) as EnTranslations;
}
